export class AppConstants {
  static permissionsList = [
    {
      value: 1,
      label: 'Чтение и Запись',
    },
    {
      value: 2,
      label: 'Чтение',
    },
    {
      value: 3,
      label: 'Недоступно',
    },
  ];

  static accessList = [
    {
      value: false,
      label: 'Разрешен',
    },
    {
      value: true,
      label: 'Запрещен',
    },
  ];

  static categoryTypesList = [
    {
      value: 'A',
      label: 'A',
    },
    {
      value: 'B',
      label: 'B',
    },
    {
      value: 'C',
      label: 'C',
    },
    {
      value: 'D',
      label: 'D',
    },
    {
      value: 'F',
      label: 'F',
    },
    {
      value: 'BE',
      label: 'BE',
    },
    {
      value: 'CE',
      label: 'CE',
    },
    {
      value: 'DE',
      label: 'DE',
    },
    {
      value: 'C1E',
      label: 'C1E',
    },
    {
      value: 'D1E',
      label: 'D1E',
    },
    {
      value: 'M',
      label: 'M',
    },
    {
      value: 'A1',
      label: 'A1',
    },
    {
      value: 'B1',
      label: 'B1',
    },
    {
      value: 'C1',
      label: 'C1',
    },
    {
      value: 'D1',
      label: 'D1',
    },
  ];
}
